import React, { Component } from 'react';
import { UncontrolledCollapse, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import product from '../../assets/img/product.png';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { AuthContext } from "../../store/provider/AuthProvider";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import Spinner from "../reusable/Loader";


export class Bonificacion extends Component {
  static displayName = Bonificacion.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      materialPromo: [],
      materialPromoI: [],
      materialPromoD: [],
      detalle: {},
      dataTab: {}
    };
  }

  checkParams() {
    const { state } = this.props.location;
    if (state) {
      console.log("materialPromo====>", state.materialPromo);
      if (state.materialPromo.length > 0) {
        var tipo = (state.materialPromo.length % 2 == 0) ? "Par" : "Impar";
        if (tipo == "Impar") {
          state.materialPromo.push({
            "canti": 0,
            "gjahr": "",
            "glosa": "",
            "kunnr": "",
            "linea": "",
            "meins": "",
            "monat": "",
            "pathI": "",
            "vkorg": "",
          });
        }
      }
      let medio = state.materialPromo.length / 2
      let i = 1
      let materialPromoI = []
      let materialPromoD = []
      // params.materialPromo.map((item, index) => {
      for (var index = 0; index <= state.materialPromo.length - 1; index++) {
        // console.log("Index===>",i, medio);
        if (i <= medio)
          materialPromoI.push(state.materialPromo[index]);
        else
          materialPromoD.push(state.materialPromo[index]);

        i = i + 1
      }
      this.setState({
        materialPromo: state.materialPromo,
        materialPromoI: materialPromoI,
        materialPromoD: materialPromoD,
        detalle: state.detalle,
        dataTab: state.dataTab,
        loading: false
      });
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }

  render() {
    const { loading, materialPromo, materialPromoI, materialPromoD, dataTab, detalle } = this.state;
    const auth = this.context;
    console.log("materialPromoI===>", materialPromoI);
    console.log("materialPromoD===>", materialPromoD);
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Metas y Bonificaciones</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/bonificaciones'>Metas y Bonificaciones</Link></li>
              <li>Detalle</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile px-5">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Metas y Bonificaciones
          </h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="estado-cuenta-date">
              <div className="content-left">
                <h5 className='paragraph-1 bold'>{dataTab.tituloMeta}</h5>
                <h1 className='title-2 mt-2 bold' style={{ color: c.verdeClaro }}>{detalle.sMontoM}</h1>
              </div>
              <div className="content-right">
                <span className='paragraph-2 light' style={{ color: c.azulClaro }}>{detalle.sMontoR}</span>
                <span className='paragraph-2' style={{ color: c.verdeClaro }}>{detalle.sPorCum}</span>
              </div>
            </div>
            <hr class="desktop mb-5" style={{ borderColor: '#E2E2E2' }} />
            <div style={{ maxWidth: 600, margin: 'auto', width: '100%' }}>
              <h6 className='paragraph-1 bold'>Hola {auth.userRazonSocial},</h6>
              <p className='paragraph-2'>{dataTab.mensaje}</p>
              {materialPromoI.map((item, index) => {
                return (
                  <div className="bonificacion_container" key={index}>
                    <SvgAssets icon="curve-top" className='curve-out' fill={c.rojoClaro} />

                    <div className="card_bonificacion">
                      <img src={item.pathI} style={{ cursor: 'pointer' }} onClick={() => this.toggleModalZoom(item.pathI)} />
                      {/* <h6 className='paragraph-2 bold'>25% de DSCTO.</h6> */}
                      <h6 className="bold">{item.glosa}</h6>
                      <span><strong>{(item.glosa == "" || item.glosa == null) ? "" : item.canti}</strong> {item.meins}</span>
                    </div>
                    {(materialPromoD[index].glosa == "" || materialPromoD[index].glosa == null) ? null :
                      <div className="card_bonificacion">
                        <img src={materialPromoD[index].pathI} style={{ cursor: 'pointer' }} onClick={() => this.toggleModalZoom(materialPromoD[index].pathI)} />
                        {/* <h6 className='paragraph-2 bold'>25% de DSCTO.</h6> */}
                        {/* <span>en repuestos de llantas</span> */}
                        <h6 className="bold">{materialPromoD[index].glosa}</h6>
                        <span><strong>{(materialPromoD[index].glosa == "") ? "" : materialPromoD[index].canti}</strong> {materialPromoD[index].meins}</span>
                      </div>}
                  </div>
                )
              })}

            </div>
          </div>
        </Container>
        <ModalImageZoom dadComponent={this} />
      </div>
    );
  }
}
